<div class="asset-details-columns flex w-full h-full">
  <div class="asset-details-main-column widget-bg-color rounded-lg grow item w-full p-4">
    <!-- Asset view -->
    <thehubz-asset-view [data]="assetInfo"></thehubz-asset-view>
  </div>
  <div class="asset-details-aside-column widget-bg-color rounded-lg item grow-0 w-2/4 h-full">
    <!-- Metadata view -->
    <thehubz-asset-version-card
      class="cursor-pointer"
      *ngFor="let version of assetInfo?.versions"
      (click)="viewSelectedVersion(version.version)"
      [assetInfo]="assetInfo"
      [version]="version"
      [defaultVersion]="assetInfo.currentVersion?._id"
      [selectedVersion]="selectedVersion"
      (deleteAssetVersionEvent)="deleteAssetVersion($event)"
    ></thehubz-asset-version-card>
  </div>
</div>
